import { asyncToGenerator as _asyncToGenerator } from '../_virtual/_rollupPluginBabelHelpers.js';

function getFetchPolyfill() {
  return _getFetchPolyfill.apply(this, arguments);
}
/**
 * Create deferred fetch polyfill
 */


function _getFetchPolyfill() {
  _getFetchPolyfill = _asyncToGenerator(function* () {
    var {
      default: fetch
    } = yield import('isomorphic-fetch');
    return fetch;
  });
  return _getFetchPolyfill.apply(this, arguments);
}

function fetch() {
  return _fetch2.apply(this, arguments);
}
/**
 * Hack to get correct protocol for given request
 * @param {ClientRequest} req
 * @returns {('http:'|'https:')}
 */

function _fetch2() {
  _fetch2 = _asyncToGenerator(function* () {
    var _fetch = process.browser ? window.fetch || (yield getFetchPolyfill()) : yield getFetchPolyfill();

    return _fetch(...arguments);
  });
  return _fetch2.apply(this, arguments);
}

function getOriginProtocol(req) {
  var host = req.headers["host"]; // `localhost:3000` is HTTP

  if (host.startsWith("localhost")) {
    return "http:";
  } // `<computer-name>.local:3000` is HTTP


  if (host.endsWith(".local") || host.includes(".local:")) {
    return "http:";
  }

  return "https:";
}

function getOrigin(req) {
  // TODO: Detect by connection type
  // Example: const protocol = req.connection.encrypted ? 'https:' : 'http:'
  // Depends on: https://herogaming.atlassian.net/browse/PD-148
  var protocol = getOriginProtocol(req);
  var host = req.headers["host"];
  return "".concat(protocol, "//").concat(host);
}
/**
 * Restrict function to be executed only once
 *
 * @param {Function} fn
 *
 * @returns {Function}
 */

function once(fn) {
  var called = false;
  return function _once() {
    if (called) {
      return;
    }

    called = true;
    return fn(...arguments);
  };
}

export { fetch, getOrigin, once };
